import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Stack,
    Typography,
    CircularProgress,
} from '@mui/material';
import RequestService from '../../services/RequestService';
import TableComponent from '../../widgets/TableComponent';
import RewardBadge from '../../widgets/RewardBadge';

import { ReactComponent as CoinIcon } from '../../assets/icons/coin.svg';
import { ReactComponent as XpIcon } from '../../assets/icons/xp.svg';

const PenaltyDialog = ({
    open,
    onClose,
    user,
    companyId,
    seasonId,
    onSuccess,
}) => {
    const [negativeAttitudes, setNegativeAttitudes] = useState([]);
    const [selectedContent, setSelectedContent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (open) {
            fetchNegativeAttitudes();
        }
    }, [open]);

    const fetchNegativeAttitudes = async () => {
        try {
            setLoading(true);
            const response =
                await RequestService.getNegativeContents(companyId);
            setNegativeAttitudes(response || []);
            setError(null);
        } catch (err) {
            setError('Failed to load negative attitudes.');
            setNegativeAttitudes([]);
        } finally {
            setLoading(false);
        }
    };

    const handleSelectContent = (content) => {
        setSelectedContent(content.id === selectedContent?.id ? null : content);
    };

    const handleApplyPenalty = async () => {
        if (!selectedContent) return;

        const payload = {
            userId: user.id,
            contentId: selectedContent.id,
            season: seasonId,
        };

        try {
            await RequestService.createNegativeUserContent(payload);
            onSuccess();
            onClose();
        } catch (err) {
            console.error('Error applying penalty', err);
        }
    };

    const columns = [
        { label: 'Título', field: 'title' },
        { label: 'Descrição', field: 'description' },
        {
            label: 'Penalidades',
            field: 'actions',
            renderCell: (value, row) => (
                <Stack direction="row" spacing={2} alignItems="center">
                    <RewardBadge
                        icon={
                            <CoinIcon
                                style={{ color: '#134F99', fontSize: '24px' }}
                            />
                        }
                        value={row.coin}
                        positive={false}
                    />
                    <RewardBadge
                        icon={
                            <XpIcon
                                style={{ color: '#134F99', fontSize: '24px' }}
                            />
                        }
                        value={row.exp}
                        positive={false}
                    />
                </Stack>
            ),
        },
    ];

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Atribuir Atitude Negativa</DialogTitle>
            <DialogContent>
                {loading ? (
                    <CircularProgress />
                ) : error ? (
                    <Typography color="error">{error}</Typography>
                ) : negativeAttitudes.length === 0 ? (
                    <Typography>Sem atitudes negativas disponíveis</Typography>
                ) : (
                    <TableComponent
                        columns={columns}
                        rows={negativeAttitudes}
                        onRowClick={handleSelectContent}
                        selectedRow={selectedContent?.id}
                    />
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">
                    Cancel
                </Button>
                <Button
                    onClick={handleApplyPenalty}
                    variant="contained"
                    color="primary"
                    disabled={!selectedContent}
                >
                    Aplicar penalidade
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PenaltyDialog;
